export class Breakpoints{
    static small = 320;
    static medium = 768;
    static large = 1024;
    static huge = 1344;
}
